define('views/shared/phone/phone',[
	'backbone',
	'views/_base/baseview',
	'text!views/shared/phone/phone.html',
	'text!views/shared/phone/almyblue-phone.html',
], function(Backbone, BaseView, Template, AlMyBlueTemplate){
	'use strict';

	return BaseView.extend({
		template : _.template(Template),
		isRender : true,
		tagName  : 'div',
		className: 'phone',
		events   : {
			'click .js-get-app-ios'    : 'goToIOSApp',
			'click .js-get-app-android': 'goToAndroidApp'
		},

		initialize: function(options){
			options = options || {};

			this.elementName = options.elementName;

			this.site_version = pf.getContent('version.id');

			this.app_store_icons = (options.app_store_icons != null || options.app_store_icons != undefined) ? options.app_store_icons : true;

			if(options.class){
				this.$el.addClass(options.class);
			}

			this.phoneTypeID = options.phoneTypeID || enums.phoneTypeID.iphone;
			this.phoneShell = options.phoneShell; // URL string
			this.phoneScreen = options.phoneScreen; // URL string or array of strings

			this.screenTemplate = '<img class="js-phone-screen phone__screen" src="{{screenURL}}" />';

			switch(this.phoneTypeID){
				case enums.phoneTypeID.iphone:
					this.$el.addClass('phone--iphone');
					break;
				// add more cases as more phone types get created
			}
			
			BaseView.prototype.initialize(this);
		},

		render: function(){

			var template = null;

			if (this.site_version == enums.siteVersion.almyblue) {
				template = _.template(AlMyBlueTemplate);
			} else {
				template = _.bind(_.template(Template), this);
			}

			this.$el.html(template());

			this.addScreens();
			this.elScreens = this.$('.js-phone-screen');

			return this;
		},

		addScreens: function(){

			this.screensMarkup = '';

			if(Array.isArray(this.phoneScreen)){

				_.each(this.phoneScreen, function(screen){
					this.screensMarkup += this.screenTemplate.replace(/{{screenURL}}/, screen);
				}, this);

			} else {

				this.screensMarkup = this.screenTemplate.replace(/{{screenURL}}/, this.phoneScreen);

			}

			this.$('.js-phone-screen-wrap').html(this.screensMarkup);
		},

		// Used by parent views
		setCurrentPhoneScreen: function(index){
			index = index || 0;

			var translateVal = 'translate(-' + index + '00%)';

			this.elScreens.css({ transform: translateVal });

		},

		goToIOSApp: function(){
			var pixel_properties = pf.getContent('analytics.pixel.track.subscribe.social');

			if(pf.fb_pixel && pixel_properties){
				pf.fb_pixel.subscribe(pixel_properties);
			}
			
			window.open(pf.getContent('global.url.app_ios'));

			return false;
		},

		goToAndroidApp: function(){
			var pixel_properties = pf.getContent('analytics.pixel.track.subscribe.social');

			if(pf.fb_pixel && pixel_properties){
				pf.fb_pixel.subscribe(pixel_properties);
			}
			
			window.open(pf.getContent('global.url.app_android'));

			return false;
		},
	 
		close: function(){}
	});
});
